module.exports = "/static/assets/12fffb88cc245027ce8ab2c020be8318.png";